import { z } from 'zod';

// Service cost schema
export const serviceCostSchema = z.object({
  serviceName: z.string(),
  cost: z.number(),
  currency: z.string(),
});

export type ServiceCost = z.infer<typeof serviceCostSchema>;

// Monthly cost summary schema
export const monthlyCostSummarySchema = z.object({
  month: z.string().regex(/^\d{4}-\d{2}$/, 'Month must be in YYYY-MM format'),
  totalCost: z.number(),
  currency: z.string(),
  services: z.array(serviceCostSchema),
  cachedAt: z.string().datetime().optional(),
});

export type MonthlyCostSummary = z.infer<typeof monthlyCostSummarySchema>;

// Query schema for billing endpoint
export const billingQuerySchema = z.object({
  month: z
    .string()
    .regex(/^\d{4}-\d{2}$/, 'Month must be in YYYY-MM format')
    .optional(),
  day: z
    .string()
    .regex(/^\d{1,2}$/, 'Day must be 1-31')
    .transform((val) => parseInt(val, 10))
    .optional(),
  refresh: z
    .string()
    .transform((val) => val === 'true')
    .optional(),
});

export type BillingQuery = z.infer<typeof billingQuerySchema>;
